import { useMemo } from 'react';
import { useQueries } from 'react-query';
import { returnTypesValueKeys, returnValueSet } from './config';
import {
  createLoadingWithError,
  createQueriesData,
  createQueriesOptions,
} from './utils';

const valueCreators = {
  [returnTypesValueKeys.loadingWithErrors]: createLoadingWithError,
  [returnTypesValueKeys.data]: createQueriesData,
};

export const useTypes = ({ importType, returnValueType }) => {
  const valueType = returnValueSet.has(returnValueType)
    ? returnValueType
    : returnTypesValueKeys.data;

  const queriesOptions = useMemo(
    () => createQueriesOptions({ importType, valueType }),
    [importType, valueType]
  );
  const queries = useQueries(queriesOptions);

  const value = useMemo(
    () => valueCreators[valueType](queries),
    [queries, valueType]
  );

  return value;
};
